import '/vodalys/vlib/js/chart.4.4.8.js';

const globalRef = typeof globalThis !== 'undefined' ? globalThis : window;
const ChartV4 = globalRef.Chart;

export default ChartV4;
 